define.alias("shared/components/shared/post/secondary/caption-writer", "calendar/components/shared/post/secondary/caption-writer");